import React from "react";
import { FenceArt, Icon, Portal } from "./registry";
/* ============================================================
   Fence Works — Specs (construction spec library)
   ============================================================ */
const SPEC_CATS = ["All", "Wood", "Vinyl", "Iron / Aluminum", "Chain Link", "Industrial"];

function SpecsPage({ store }: any) {
  const [cat, setCat] = React.useState<any>("All");
  const [open, setOpen] = React.useState<any>(null);
  const [cmpA, setCmpA] = React.useState<any>(""); const [cmpB, setCmpB] = React.useState<any>("");
  const [lf, setLf] = React.useState<any>(""); const [prodId, setProdId] = React.useState<any>("");
  const specs = window.VFP_SPECS;
  const list = cat === "All" ? specs : specs.filter(s => s.c === cat);

  const prod = window.VFP.PRODUCTS.find(p => p.id === prodId);
  const est = (lf && prod) ? window.VFP.computeQuote({ linearFeet: +lf }, prod, store.settings) : null;

  return (
    <div className="page fade-up">
      <div className="settings-grid">
        {/* left rail */}
        <aside className="set-side">
          <div className="card pad">
            <div className="kicker" style={{ marginBottom: 12 }}>Material Cost Estimator</div>
            <label className="field-label">Linear Feet</label>
            <input className="input tnum" type="number" placeholder="100" value={lf} onChange={e => setLf(e.target.value)} />
            <label className="field-label" style={{ marginTop: 10 }}>Product</label>
            <select className="select" value={prodId} onChange={e => setProdId(e.target.value)}>
              <option value="">Select product…</option>
              {window.VFP.PRODUCTS.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
            <div className="card" style={{ marginTop: 12, padding: 12, background: "var(--surface-2)" }}>
              {est
                ? <div style={{ display: "grid", gap: 7 }}>
                    <Rowlet k="Material" v={window.VFP.money0(est.materialTotal)} />
                    <Rowlet k="Customer $/ft" v={window.VFP.money(est.customerTotal / +lf)} accent />
                    <Rowlet k="Quote total" v={window.VFP.money0(est.customerTotal)} accent />
                  </div>
                : <p className="muted" style={{ fontSize: 12.5, margin: 0, textAlign: "center" }}>Enter footage and select a product</p>}
            </div>
          </div>
          <div className="card pad">
            <div className="kicker" style={{ marginBottom: 12 }}>Quick Measurement Ref</div>
            <div className="muted" style={{ fontSize: 12.5 }}>Panel spacing</div>
            <div className="mono" style={{ fontSize: 13, marginTop: 4, color: "var(--teal)" }}>Wood/Vinyl 8' · Chain 10' O.C.</div>
            <div className="muted" style={{ fontSize: 12.5, marginTop: 10 }}>Posts for 100 ft @ 8'</div>
            <div className="mono" style={{ fontSize: 13, marginTop: 4 }}>≈ 14 posts (13 panels + 1)</div>
          </div>
        </aside>

        {/* main */}
        <main>
          <h1 className="display" style={{ fontSize: 30, margin: 0 }}>Construction Specs</h1>
          <p className="muted" style={{ margin: "5px 0 18px" }}>Detailed engineering specs for every fence and gate type. Click any card to view the full spec sheet.</p>
          <div className="cat-tabs" style={{ borderBottom: "1px solid var(--line)", gap: 0, marginBottom: 20 }}>
            {SPEC_CATS.map(c => (
              <button key={c} className={"spec-tab" + (cat === c ? " on" : "")} onClick={() => setCat(c)}>{c}</button>
            ))}
          </div>
          <div className="prod-grid">
            {list.map((s, i) => (
              <button key={i} className="prod-card" style={{ textAlign: "left", display: "block", width: "100%" }} onClick={() => setOpen(s)}>
                <div className="prod-swatch" style={{ height: 120, background: "var(--surface-2)" }}>
                  <FenceArt type={s.glyph} width={240} height={120} />
                </div>
                <div style={{ padding: "13px 14px 6px" }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{s.n}</div>
                  <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>{s.sub}</div>
                </div>
                <div className="prod-spec" style={{ margin: "8px 14px 0" }}>
                  {s.f.map(([l, v], k) => <div key={k}><div className="spec-lbl">{l}</div><div className="spec-val">{v}</div></div>)}
                </div>
                <div style={{ padding: "12px 14px 14px", color: "var(--teal)", fontWeight: 700, fontSize: 13 }} className="row between">
                  View Full Spec Sheet <Icon name="arrow" size={14} />
                </div>
              </button>
            ))}
          </div>
        </main>

        {/* right rail */}
        <aside className="set-side">
          <div className="card pad">
            <div className="row between" style={{ marginBottom: 12 }}><span className="kicker">Spec Compare</span><span className="chip" style={{ fontSize: 10.5, padding: "1px 7px" }}>Pick 2</span></div>
            {[["Spec A", cmpA, setCmpA], ["Spec B", cmpB, setCmpB]].map(([lb, val, set]) => (
              <div key={lb} style={{ marginBottom: 10 }}>
                <label className="field-label">{lb}</label>
                <select className="select" value={val} onChange={e => set(e.target.value)}>
                  <option value="">Select spec…</option>
                  {specs.map((s, i) => <option key={i} value={s.n}>{s.n}</option>)}
                </select>
              </div>
            ))}
            {cmpA && cmpB
              ? (() => { const A = specs.find(s => s.n === cmpA), B = specs.find(s => s.n === cmpB);
                  return <div className="card" style={{ marginTop: 4, padding: 10, background: "var(--surface-2)" }}>
                    {A.f.map(([l], k) => <div key={k} style={{ padding: "5px 0", borderBottom: "1px solid var(--line)" }}>
                      <div className="spec-lbl">{l}</div>
                      <div className="row between" style={{ fontSize: 12 }}><span className="mono" style={{ color: "var(--teal)" }}>{A.f[k][1]}</span><span className="mono muted">{(B.f[k] || ["", "—"])[1]}</span></div>
                    </div>)}
                  </div>; })()
              : <p className="muted" style={{ fontSize: 12, textAlign: "center", margin: "6px 0 0" }}>Select two specs to compare</p>}
          </div>
        </aside>
      </div>

      {open && <SpecModal spec={open} onClose={() => setOpen(null)} />}
    </div>
  );
}

function Rowlet({ k, v, accent }: any) {
  return <div className="row between" style={{ fontSize: 13 }}><span className="muted">{k}</span><span className="tnum" style={{ fontWeight: 700, color: accent ? "var(--teal)" : "var(--fg)" }}>{v}</span></div>;
}

function SpecModal({ spec, onClose }: any) {
  return (
    <Portal>
    <div className="modal-scrim" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="row between" style={{ marginBottom: 18 }}>
          <div><h2 className="display" style={{ fontSize: 22, margin: 0 }}>{spec.n}</h2><div className="muted" style={{ fontSize: 13 }}>{spec.sub}</div></div>
          <div className="row gap-8">
            <button className="btn btn-ghost btn-sm" onClick={() => window.print()}><Icon name="printer" size={14} />Print Spec</button>
            <button className="icon-btn" onClick={onClose}><Icon name="x" size={18} /></button>
          </div>
        </div>
        <div className="spec-modal-grid">
          <div className="card" style={{ background: "var(--surface-2)", padding: 0, overflow: "hidden" }}>
            <FenceArt type={spec.glyph} width={360} height={230} />
          </div>
          <div className="prod-spec" style={{ gridTemplateColumns: "1fr 1fr", alignSelf: "start" }}>
            {spec.f.map(([l, v], k) => <div key={k}><div className="spec-lbl">{l}</div><div className="spec-val" style={{ fontSize: 15 }}>{v}</div></div>)}
          </div>
        </div>
        <div className="card" style={{ marginTop: 16, padding: 14, borderLeft: "3px solid var(--teal)" }}>
          <div className="kicker kicker-teal" style={{ marginBottom: 6 }}>{spec.c}</div>
          <p className="muted" style={{ margin: 0, fontSize: 13 }}>Reference sheet for {spec.n}. Quantities on a quote come from your own product's component list (Products &amp; Pricing) — use this spec to build that list, and to answer "what goes into a panel" for the crew.</p>
        </div>
      </div>
    </div>
    </Portal>
  );
}

Object.assign(window, { SpecsPage, SpecModal, Rowlet });

export { SpecsPage, Rowlet, SpecModal, SPEC_CATS };
